import React from "react";
import logo from "../../../images/logo.png";

import { FiPackage, FiShoppingBag } from "react-icons/fi";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";


const DashboardHeader = () => {
  const { seller } = useSelector((state) => state.seller);
  return (
    <div className="w-full h-[80px] bg-white shadow sticky top-0 left-0 z-30 flex items-center justify-between px-4">
      <div className="flex items-center">
        <Link to="/dashboard">
          <img src={logo} alt="logo" className="w-[40px] h-[40px]" />
        </Link>
      </div>
      <div className="flex items-center">
        <div className="flex items-center mr-4">
         
          <Link to="/dashboard-products" className="800px:block hidden">
            <FiShoppingBag
              color="#555"
              size={30}
              className="mx-5 cursor-pointer"
            />
          </Link>
          <Link to="/dashboard-orders" className="800px:block hidden">
            <FiPackage color="#555" size={30} className="mx-5 cursor-pointer" />
          </Link>
      
            <img
              src={seller.avatar?.url}
              alt={seller.name}
              className="w-[50px] h-[50px] rounded-full object-cover"
            />
          
        </div>   
      </div>
    </div>
  );
};

export default DashboardHeader;
